import React from 'react';

// Logo oficial Incubatour — imagotipo completo (isotipo + wordmark), PNG transparente, versión para fondo oscuro.
const Logo = ({ size = 32, className = '' }) => (
    <img
        src="/assets/incubatour-logo-white.png"
        alt="Incubatour"
        style={{ height: size, width: 'auto' }}
        className={`object-contain ${className}`}
    />
);

export default Logo;
